import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { getNotification } from "../../../service/Notification/NotificationService";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import AppTheme from "../../../theme/AppTheme";
import { Box, CssBaseline, Tooltip } from "@mui/material";
import { dataGridCustomizations } from "../../../theme/customizations";
import {
  notificationMessage,
  updateNotificationFunction,
} from "./utils/reuseFunction";
import { setActiveKey, tabStep } from "../../../Redux/Slices/tabSlice"; 
import { useAppDispatch } from "../../../Redux/hooks";

const xThemeComponents = {
 ...dataGridCustomizations,
};

const columns: GridColDef[] = [
  { field: "message", headerName: "Notification", flex: 1 },
  {
    field: "status",
    headerName: "Status",
    width: 200,
    renderCell: (params) => {
      return params.row.status === null ? null : params.row.status ? (
        <Tooltip title="Mark as read" placement="right-end">
          <DraftsOutlinedIcon />
        </Tooltip>
      ) : (
        <Tooltip title="Mark as unread" placement="right-end">
          <MarkunreadOutlinedIcon />
        </Tooltip>
      );
    },
  },
];

const NotificationGrid: React.FC = () => {
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState<any[]>([]);
  const { store_id } = useParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getNotification();
        if (response.status === 200 || response.status === 201) {
          setNotificationData(response.data.data);
        }
      } catch (error) { }
    };
    fetchNotifications();
  }, []);

  const rows =
    notificationData.length > 0
      ? notificationData.map((values: any) => ({
        id: values.id,
        type: values.type,
        message: notificationMessage(values.type, values.order),
        status: values.is_read,
        orderId: values.order,
        invoiceId: values.invoice,
      }))
      : [
        {
          id: 0,
          message: "No Notifications",
          status: null,
        },
      ];

  return (
    <AppTheme themeComponents={xThemeComponents}>
      <Box style={{ height: 500, width: "100%" }}>
        <CssBaseline />
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          disableRowSelectionOnClick
          onRowClick={(params) => {
            const { type, id, orderId, invoiceId } = params.row;
             const path =  `/stores/${store_id}/orders`
                // dispatch(setActiveKey(type === "invoice" ? "return" : "orders" as tabStep));
                navigate(path,{
                  state:{
                    triggerId: orderId || invoiceId,
                    triggerType: type,
                    fromNotification: true,
                  }
                });
            updateNotificationFunction(id, { is_read: true });
          }}
          sx={{
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
              marginTop: 1,
            },
          }}
          pageSizeOptions={[10]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }}
        />
      </Box>
    </AppTheme>
  );
};

export default NotificationGrid;
